import { Button } from 'antd'

const FormActions = ({
	t,
	setIsConfirmModalVisible,
	onSubmit,
	btnLoading,
	imageList,
}) => (
	<div className={'flex mt-10 w-full items-center gap-10'}>
		<Button
			onClick={() => setIsConfirmModalVisible(true)}
			type={'danger'}
			className="w-full bg-red-600 text-white"
		>
			{t('back')}
		</Button>
		<Button
			onClick={onSubmit}
			loading={btnLoading}
			disabled={
				btnLoading ||
				(imageList.every((image) => image.file) &&
					!imageList.every((image) => image.path))
				// !tableData.length === 0 ||
				// !clientCode ||
				// !departmentAdmin ||
				// !slpCode ||
				// !dateSale ||
				// !whs
			}
			type={'primary'}
			className="w-full"
		>
			{t('create')}
		</Button>
	</div>
)

export default FormActions
